module.exports = __webpack_public_path__ + "acd31cf61f3cc49ea0412e8ee9d44276.svg";